/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppTitle } from './title';
import { OneRosterService } from './oneroster.service';
import { Alert } from './alert';
import { Registration } from './registration';
import { User } from './user';
import { validateToken } from './account.service';
import { RegistrationFind } from './registration_find';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { controlErrors } from './app.validators';
import { trimReturnKey } from './strings';
import { RegistrationRequest } from './registration_request';
import { FindAccountAssociation } from './account_association_find';
import { RegistrationSyncRequest } from './registration_sync_request';
import { isDateSet, dateFormat } from './date_helper';

@Component({
	selector: 'sync',
	styles: [`
        .tag {
            margin-right:2px;
            background-color:#9dbd9e;
            border-radius:4px;
            padding:5px;
        }
        .tag-close {
            margin-left:5px;
            cursor: pointer;
        }
        .mt2 {
            margin-top: 15px;
        }
    `],
	template: `
        <div class="col-lg-6 col-md-8 col-xs-12">
            <p style='color: #919191;'>Sync Settings</p>
            <div class="customHr" style="width:150px">.</div>
            <form [formGroup]="form" novalid>
                    <div class="row">
                        <div class="col-md-6 col-xs-12" style="margin-bottom: 0px;padding-left:0px!important;">
                            <div class="form-group">
                                <p class="custom-label">Sync Cron Job</p>
                                <input style="margin-bottom: 5px;" type="text" [(ngModel)]="data.syncCrunJob" formControlName="syncCrunJob" class="form-control" placeholder="Sync Cron Job" title="Sync Cron Job">
                                <a href="https://crontab.guru" target="_blank">Generate Here</a>
                            </div>
                        </div>
                    </div>
            </form>

            <p style='color: #919191; margin-top: 20px'>Sync Status</p>
            <div class="customHr" style="width:140px">.</div>

            <p>Number of Students: {{data.studentCount}}</p>
            <p>Number of Students Contacts: {{data.studentContactCount}}</p>
            <p>Number of Organization: {{data.organizationCount}}</p>
            <p>Last Sync At: {{printDate(data.lastSyncedAt)}}</p>
            <p>Sync Error: {{data.lastSyncError != "" ? data.lastSyncError : 'No errors'}}</p>
				<p>Last Sync Error At: {{printDate(data.lastSyncErrorAt)}}</p>
            <p>Sync Status: {{syncStatusTitle}}</p>

            <div class="row mt2">
                <button [disabled]="!showSaveButton" type="button" class="btn btn-large btn-primary" (click)="save()">{{ saveTitle }}</button>
                <a type="button" class="btn btn-large btn-deny" style="margin-left:10px; cursor: pointer;" (click)="refresh()">Refresh</a>
                <a style="margin-left:10px;cursor: pointer;" (click)="goBack()">Go Back</a>
            </div>

            <div class="row mt2" [hidden]="msg.msg == ''">
                <alert [alert]="msg"></alert>
            </div>
        </div>
    `
})

export class SyncComponent implements OnInit {
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	hasAccess: boolean;
	maxPageSize: number;
	idParam: string;
	form: FormGroup;
	data: Registration;
	saveCount: number;
	saveTitle: string; // is for button title only
	syncStatusTitle: string; // is for displaying sync status only
	syncStatus: string; // is real status value
	showSaveButton: boolean;

	constructor(private router: Router, private orvc: OneRosterService, private title: AppTitle, private activatedRoute: ActivatedRoute, fb: FormBuilder) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'Registration Sync',
			dashboard: 'Registration Sync'
		});

		this.form = fb.group({
			syncCrunJob: ['', Validators.compose([Validators.required])],
		});
		this.saveCount = 1;

		this.data = new Registration();
		this.saveTitle = '';
		this.syncStatusTitle = '';
		this.syncStatus = '';
		this.showSaveButton = false;
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		this.idParam = this.activatedRoute.snapshot.params['id'];

		this.title.setBreadcrumbs([
			{ title: 'Registrations ', link: `/settings/${this.acctNumber}/registrations` },
			{ title: this.idParam + ' ', link: `` },
			{ title: 'Sync', link: `` }
		]);

		if (this.acctNumber != null) {
			this.orvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error(`You don't have access to this district number ${this.acctNumber}`);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.orvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				})
		}
		this.loadData();
	}

	loadData() {
		let find = new RegistrationFind();
		find.id = parseInt(this.idParam);

		this.orvc.registrationFindApi(this.acctNumber, find)
			.subscribe((rows: Registration[]) => {
				this.msg.close();
				this.data = rows[0];
				this.form.get('syncCrunJob').setValue(this.data.syncCrunJob);

				this.saveTitle = this.statusSaveTitle(this.data.syncStatus);
				this.showSaveButton = false;
				if (this.data.syncStatus !== 'disabled') {
					this.showSaveButton = true;
				}
				console.log(this.showSaveButton);
				this.syncStatus = this.data.syncStatus;
				this.syncStatusTitle = this.data.syncStatus;

				this.checkForAccountAssociation();
			}, err => {
				console.log(err);
				if (this.orvc.isErrNotFound(err)) {
					this.msg.warning(this.orvc.getUserError(err));
				} else {
					if (this.orvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.orvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.orvc.getUserErrorDefault(err));
					}
				}
			});
	}

	checkForAccountAssociation() {
		let findc = new FindAccountAssociation();
		findc.registrationId = parseInt(this.idParam);
		this.orvc.accountAssociationFindCountApi(this.acctNumber, findc)
			.subscribe((row) => {
				if (row.count == 0) {
					setTimeout(() => {
						this.msg.warningHtml("School Mapping not completed for this registration!")
					}, 500);
				}
			}, err => {
				console.log(err);
				if (this.orvc.isErrNotFound(err)) {
					this.msg.warning(this.orvc.getUserError(err));
				} else {
					if (this.orvc.isErrUnauthorized(err)) {
						this.hasAccess = false;
						this.msg.error(this.orvc.getUserErrorDefault(err));
					} else {
						this.msg.error(this.orvc.getUserErrorDefault(err));
					}
				}
			});
	}

	viewToRequest(r: Registration): RegistrationRequest {
		let ret = new RegistrationRequest();
		ret.oneRosterApiVersion = trimReturnKey(r.oneRosterApiVersion);
		ret.syncCrunJob = trimReturnKey(r.syncCrunJob);
		ret.oneRosterApiUrl = trimReturnKey(r.oneRosterApiUrl);
		ret.oauthClientId = trimReturnKey(r.oauthClientId);
		ret.oauthClientSecret = trimReturnKey(r.oauthClientSecret);
		ret.oauthVersion = trimReturnKey(r.oauthVersion);
		return ret;
	}

	save() {
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}

		let regSyncRequest = new RegistrationSyncRequest();
		regSyncRequest.status = this.syncStatus;

		switch (regSyncRequest.status) {
			case 'initialized':
			case 'error':
			case 'stopped':
				regSyncRequest.status = 'starting';
				break;
			case 'started':
				regSyncRequest.status = 'stopping';
				break;
			// when status is pending then we need to allow user to stop the process
			case 'starting':
			case 'initializing':
			case 'stopping':
				regSyncRequest.status = 'stopping';
				break;
			case '':
			case 'error-initializing':
				regSyncRequest.status = 'initializing';

			default:

		}
		console.log(regSyncRequest);

		regSyncRequest.syncCrunJob = this.form.get('syncCrunJob').value;

		this.orvc.registrationSyncApi(this.acctNumber, this.data.id, regSyncRequest)
			.subscribe(res => {
				let saveMessage = this.orvc.getDefaultSaveMessage();
				if (this.saveCount > 1) {
					saveMessage += ` (${this.saveCount})`
				}
				this.saveCount++;
				this.msg.success(saveMessage);
				setTimeout(() => {
					this.loadData();
				}, 1000);
			}, err => {
				console.log(err);
				let e = this.orvc.getUserErrorDefault(err);
				this.msg.error(e);
			});
	}

	statusSaveTitle(st: string): string {
		switch (st) {
			case '':
			case 'error-initializing':
				return 'Start Initialization';
			case 'initializing':
				return 'Stop Initialization';
			case 'stopped':
			case 'initialized':
			case 'error':
				return 'Start Syncing';
			case 'starting':
			case 'stopping':
			case 'started':
				return 'Stop Syncing';
			case 'disabled':
				return 'Disabled';
		}
		return '';
	}

	refresh() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		this.loadData();
		this.msg.close();
	}

	goBack() {
		this.router.navigate([`/settings/${this.acctNumber}/registrations`]);
		return;
	}

	displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

	printDate(d: Date): string {
		let df = '01/02/2006 03:04 PM';
		if (isDateSet(d)) {
			return dateFormat(d, df);
		}
		return '';
	}
}